module.exports = __webpack_public_path__ + "static/media/email.af785915.png";